import { FormEvent, useState } from "react";
import { formSubmitEndpoint } from "../formSubmit";
import { routeHref } from "../routes";
import "./NewsletterSignup.scss";

type SendState = "idle" | "sending" | "sent" | "error";

export function NewsletterSignup() {
  const [sendState, setSendState] = useState<SendState>("idle");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!formSubmitEndpoint) return;
    const form = event.currentTarget;
    const data = new FormData(form);

    setSendState("sending");
    try {
      const response = await fetch(formSubmitEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          nume: String(data.get("familyName") || "").trim(),
          prenume: String(data.get("givenName") || "").trim(),
          email: String(data.get("email") || "").trim(),
          message: "Cerere de abonare la noutățile AUPPS.",
          consimtamant: "Doresc să primesc noutăți prin email.",
          _subject: "Cerere abonare la noutățile AUPPS",
          _captcha: "false",
          _honey: String(data.get("_honey") || ""),
          _url: window.location.href,
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || (result?.success !== true && result?.success !== "true")) {
        setSendState("error");
        return;
      }
      form.reset();
      setSendState("sent");
    } catch {
      setSendState("error");
    }
  }

  return (
    <section className="newsletter-signup" aria-labelledby="newsletter-signup-title">
      <div className="newsletter-signup__intro">
        <p className="eyebrow eyebrow--lime">RĂMÂNEM ÎN LEGĂTURĂ</p>
        <h3 id="newsletter-signup-title">Abonează-te la noutăți</h3>
        <p>Articole, ateliere și vești din comunitatea noastră.</p>
      </div>
      <form className="newsletter-signup__form" onSubmit={handleSubmit}>
        <div className="newsletter-signup__fields">
          <label>Nume<input name="familyName" autoComplete="family-name" required /></label>
          <label>Prenume<input name="givenName" autoComplete="given-name" required /></label>
          <label>Email<input name="email" type="email" autoComplete="email" required /></label>
          <button type="submit" disabled={sendState === "sending" || !formSubmitEndpoint}>
            {sendState === "sending" ? "Se trimite…" : "Înscrie-te"}<span aria-hidden="true">↗</span>
          </button>
        </div>
        {!formSubmitEndpoint && <p className="newsletter-signup__feedback" role="status">Înscrierea este disponibilă doar pe site-ul oficial.</p>}
        <label className="newsletter-signup__consent">
          <input name="consent" type="checkbox" required />
          <span>Sunt de acord să primesc noutăți prin email.</span>
        </label>
        <input className="newsletter-signup__honeypot" name="_honey" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" />
        {sendState === "sent" && <p className="newsletter-signup__feedback" role="status">Cererea ta de abonare a fost trimisă.</p>}
        {sendState === "error" && <p className="newsletter-signup__feedback newsletter-signup__feedback--error" role="alert">Cererea nu a putut fi trimisă. Încearcă din nou mai târziu.</p>}
        <p className="newsletter-signup__privacy">Află cum folosim datele tale în <a href={routeHref("/politica-de-confidentialitate")}>Politica de confidențialitate</a>.</p>
      </form>
    </section>
  );
}
